/**
 * Plans v2 card 2.1 (owner, 15.10.2026: "user account login, required for
 * all, no local users"): the desktop app shows sign-in until there is a
 * session, like web.apiboo.com already does (platform/webGate.js).
 *
 *   'app'     render the app: signed in, or not the real desktop app
 *   'loading' desktop, the stored session is still being checked (a
 *             cold start offline keeps a stored session: authStore)
 *   'signin'  desktop, no session: the title bar and the sign-in page only
 *
 * A recorded demo or e2e run is not gated — but only in a build MADE for
 * that (`REACT_APP_E2E_NO_GATE=1`, `npm run build:e2e`; platform/gateExempt.js).
 * The release build always gates, even with `window.__demoIpc` set at runtime:
 * `isSyntheticRun` alone is a metrics marker, not a security boundary.
 * Local data from before the update is merged into the account at the first
 * sign-in (guest → login merge, hooks/useWorkspaceBootstrap).
 *
 * Offline past the signed plan claim's 14 days (owner, 16.10.2026, card 2.4;
 * `claim` from plans/claimExpiry.js): 'expired' requires sign-in again
 * ('signin'), 'checking' waits for the server ('loading'). Nothing is
 * deleted; the data comes back as soon as the server confirms the account.
 */
import { isWebApp } from './target';
import { isTauri } from '../utils/tauri';
import { isGateExemptRun } from './gateExempt';

export function desktopGateState({ isInitialized, isAuthenticated, claim = 'ok' }) {
  if (isWebApp() || !isTauri() || isGateExemptRun()) return 'app';
  if (!isInitialized) return 'loading';
  if (!isAuthenticated) return 'signin';
  if (claim === 'expired') return 'signin';
  if (claim === 'checking') return 'loading';
  return 'app';
}
